import Api from "@/utils/Api";
import $cookies from "vue-cookies";
export default {
  namespaced: false,
  state: {
    auth: $cookies.get("setutsa-s-auth")
  },
  getters: {
    auth: state => state.auth,
    token: state => (state.auth || {}).token
  },
  mutations: {
    auth(state, auth) {
      $cookies.set("setutsa-s-auth", auth, "6h");
      state.auth = auth;
    },
    deAuth: state => {
      $cookies.remove("setutsa-s-auth");
      state.auth = null;
      localStorage.clear();
    }
  },
  actions: {
    deAuth: async ({ commit }) => {
      return new Promise(resolve => {
        commit("deAuth");
        resolve();
      });
    },
    auth: async ({ commit }, authData) => {
      const { error, status, data } = await Api.post(
        "usuarios/login",
        authData
      );
      if (data && data.token) {
        commit("auth", data);
      }
      return {
        error,
        status
      };
    }
  }
};
